import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import arrowDown from '../../../assets/images/icons/arrowDown.svg';
import arrowDownBlack from '../../../assets/images/icons/arrowDownBlack.svg';
import { WHITE, GRAY_TEXT, LABEL_COLOR, PINK } from '../../../constants/colors';

export default {
  wrapper: ({ hasBlackTheme, isSorting }) => css`
    display: flex;
    flex-direction: column;

    ${media.sm && css`
    `}

    ${hasBlackTheme && css`
      margin-bottom: 24px;
    `}

    ${isSorting && css`
      margin: 0;
      padding: 0;
    `}
  `,
  selectWrapper: css`
    position: relative;
  `,
  select: ({ hasBlackTheme, value, isSorting, status }) => css`
    position: relative;
    color: ${hasBlackTheme || isSorting ? LABEL_COLOR : WHITE};
    width: 100%;
    font-size: ${isSorting ? rem('12px') : rem('16px')};
    border: none;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    background-image: none;
    border-color: ${status ? '#28A745' : PINK};
    appearance: none;
    -moz-appearance: none; 
    -webkit-appearance: none; 
    outline: none;
    background-color: white;
    border-bottom: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};

    &:focus {
      border-bottom: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? LABEL_COLOR : WHITE}`};
    }

    ${value === '' && hasBlackTheme && css`
      color: #757575;
    `}

    ${isSorting && css`
      border: none;
    `}

    option {
      background-color: white;
      color: black;
      font-size: ${rem('16px')};
    }
  `,
  input: ({ type, hasBlackTheme, value, isSorting, textColor, status }) => css`
    position: relative;
    color: ${hasBlackTheme || isSorting ? LABEL_COLOR : GRAY_TEXT};
    ${textColor && css`
        color: ${textColor};
    `}
    width: 100%;
    font-size: ${isSorting ? rem('12px') : rem('16px')};
    border: none;
    box-shadow: none;
    border-radius: 12px;
    padding: 0.25em;
    background-color: transparent;
    background-image: none;
    appearance: none;
    outline: none;
    border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? '#ccc' : GRAY_TEXT}`};
    border-color: ${status ? '#28A745' : PINK};

    &:focus {
      border: ${isSorting ? 'none' : `1px solid ${hasBlackTheme ? LABEL_COLOR : GRAY_TEXT}`};
      border-color: ${status ? '#28A745' : PINK};
    }

    ${value === '' && hasBlackTheme && css`
      color: #757575;
    `}

    ${isSorting && css`
      border: none;
    `}

    ${type === 'date' && !textColor && css`
      min-height: 2em;
      &::-webkit-calendar-picker-indicator {
      }
    `}
    option {
      color: black;
      font-size: ${rem('16px')};
    }
  `,

  selectArrow: ({ hasBlackTheme, isSorting }) => css`
    position: absolute;
    bottom: ${isSorting ? 6 : 8}px;
    right: ${isSorting ? 12 : 8}px;
    width: 10px;
    height: 6px;
    background-image: url(${hasBlackTheme || isSorting ? arrowDownBlack : arrowDown});
    background-repeat: no-repeat;
    pointer-events: none;
  `,
  name: ({ color }) => css`
    color: ${color || GRAY_TEXT};
    font-size: ${rem('10px')};
    margin-top: 4px;
  `
};
